import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';

const Features = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section
      className="py-10 md:py-16 lg:py-24 flex items-center bg-surface-section relative overflow-hidden border-b border-edge-light"
      dir={language === 'ar' ? 'rtl' : 'ltr'}
    >
      {/* Background globe pattern */}
      <div
        className="absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage: `url(/glob.webp)`,
          backgroundRepeat: 'repeat',
          backgroundSize: '300px',
        }}
      />

      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="font-ibm text-[26px] leading-[1.5] md:text-[34px] md:leading-[1.45] font-bold text-heading mb-4">
            {language === 'ar' ? (
              <>
                <span className="text-primary">منصة واحدة</span>... لإدارة جميع متاجرك الإلكترونية
              </>
            ) : (
              <>
                <span className="text-primary">One Platform.</span>{" "}
                Every Marketplace.
              </>
            )}
          </h2>
          <p
            className="font-almarai text-[16px] md:text-[18px] text-body-subtitle leading-[1.8]"
            dangerouslySetInnerHTML={{ __html: t.onePlatformDesc }}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default memo(Features);
